import { Model } from '../abstracts/model';
import { FilterValueModel } from './filter-value.model';

export class FilterModel extends Model {
  id: number;
  slug: string;
  title: string;
  description: string;
  values: FilterValueModel[];

  override onInit(): void {
    if (this?.values?.length) {
      this.values = this.values.map((itm) => new FilterValueModel(itm));
    }
  }
}
